import React, { Component, Fragment } from 'react';
import { withNamespaces } from 'react-i18next';
import AddMemberModal from 'modules/family/components/add-member/add-member-modal';
import { inject, observer } from 'mobx-react';

@withNamespaces()
@inject('store')
@observer
class AddMemberButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.setState({modalOpen: true});
    }

    closeModal() {
        this.setState({modalOpen: false});
    }

    render() {
        if (!this.props.store.user.familyOwnerActions) {
            return null;
        }

        const { t } = this.props;
        const { modalOpen } = this.state;

        const modal = modalOpen ? (
            <AddMemberModal close={this.closeModal} dismiss={this.closeModal}/>
        ) : null;

        return (
            <Fragment>
                <button onClick={this.openModal} type="button" className="btn btn-xs btn-default">
                    {t('FAMILY.MANAGE.ADD_MEMBER.BUTTON')}
                </button>
                {modal}
            </Fragment>
        );
    }
}

export default AddMemberButton;


// WEBPACK FOOTER //
// ./src/modules/family/components/add-member/add-member-button.js